export * from './new-contacto-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/new-contacto-dialog/index.ts